import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { slideInAndOutAnimation } from '~lmo/animations';
import { Frac, FracClusterTruckingVendor } from '~lmo/models/frac.model';
import { Order } from '~lmo/models/order.model';
import { LmoOrdersService } from '~lmo/services';
import { fctvSorter, LmoFracFctvsService } from '~lmo/services/lmo-frac-fctvs.service';
import { HelperService } from '~services/helper.service';

@Component({
  animations: [slideInAndOutAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-reassign-vendor',
  styleUrls: ['./lmo-reassign-vendor.component.scss'],
  templateUrl: './lmo-reassign-vendor.component.html',
})
export class LmoReassignVendorComponent implements OnInit {
  public vendor: FormControl = new FormControl(null);
  public truckingVendors$: Observable<FracClusterTruckingVendor[]>;
  public currentOrder$: Observable<Order>;
  public currentFrac$: Observable<Frac>;
  constructor(
    private fctvService: LmoFracFctvsService,
    private orderService: LmoOrdersService,
    private matDialogRef: MatDialogRef<LmoReassignVendorComponent>,
    public helperService: HelperService,
  ) {}

  public ngOnInit() {
    this.currentOrder$ = this.orderService.currentOrder$;

    this.truckingVendors$ = combineLatest(this.currentOrder$, this.fctvService.currentFracFctvs$).pipe(
      map(([currentOrder, fctvs]) =>
        fctvs.filter((fctv) => fctv.status === 'awarded' && fctv.truckingVendorId !== currentOrder.vendor.id),
      ),
      map(fctvSorter),
    );
  }

  public reassign() {
    const fctv: FracClusterTruckingVendor = this.vendor.value;
    if (!fctv || !fctv.truckingVendorId) {
      return;
    }

    this.orderService.reassignVendor$(fctv.truckingVendorId).subscribe((successful) => {
      if (successful) {
        this.matDialogRef.close();
      }
    });
  }
}
